import { render } from "./help.vue?vue&type=template&id=28a60206&scoped=true"
const script = {}

import "./help.vue?vue&type=style&index=0&id=28a60206&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\zoinix-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28a60206"]])

export default __exports__